module.exports = __webpack_public_path__ + "img/v4_checkingConfig.05ce1c62.png";